<template>
    <section class="relative flex flex-col pr-0 md:pr-20" :style="{ paddingLeft: 'calc(' + options.fontSizeVerticalText + ' + 1.6rem )' }">
        <VerticalText
            :style="{ fontSize: options.fontSizeVerticalText }"
            :options="{
                verticalText: options.verticalText,
                color: 'flamingo'
            }"
        />
        <slot></slot>
    </section>
</template>

<script>
    export default {
        name: 'SectionVerticalTextParagpraphs',
        props: {
            options: null
        }
    };
</script>

<style lang="scss" scoped></style>
